define('showInactiveCommunityModule',[], function () {

    // Back to top functionality
    var backToTopElements = document.querySelectorAll("a[href='#top']");
    for (var i = 0; i < backToTopElements.length; i++) {
        backToTopElements[i].addEventListener("click",
            function (event) {
                event.preventDefault();
                window.scrollTo({
                    top: 0,
                    left: 100,
                    behavior: "smooth"
                });
            });
    };

    // Show the map once require has been downloaded
    var mapSectionDiv = document.getElementById("nhs_inactiveCommunityMapContainer");

    if (mapSectionDiv) {
        mapSectionDiv.style.display = "block";
    }

    // Open the map & directions section
    (function () {
        var mapSection = document.getElementById("dd-collapsible");
        var openMapButton = document.getElementById("nhs_propertyMapCollapsibleOpen");
        var closeMapButton = document.getElementById("nhs_propertyMapCollapsibleClose");

        openMapButton.addEventListener("mousedown", function (event) {
            event.preventDefault();
            mapSection.style.display = "block";
            openMapButton.style.display = "none";
            closeMapButton.style.display = "block";

            require(["basicCommunitiesMaps"], function (mapSection) {
                mapSection.init();
            });
        });

        closeMapButton.addEventListener("mousedown",
            function (event) {
                event.preventDefault();
                mapSection.style.display = "none";
                openMapButton.style.display = "block";
                closeMapButton.style.display = "none";
            }
        );

    })();
});
